import { createSlice } from "@reduxjs/toolkit";
import { inviteDriver } from "../thunks/inviteDriverThunk";

const inviteDriverSlice = createSlice({
  name: "driver",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
    driver: null,
  },
  reducers: {
    resetDriverInviteStatus: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(inviteDriver.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(inviteDriver.fulfilled, (state, action) => {
        state.driver = action.payload;
        state.status = "success";
        state.error = null;
      })
      .addCase(inviteDriver.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetDriverInviteStatus } = inviteDriverSlice.actions;
export default inviteDriverSlice.reducer;
